import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { IDENTITY_PROVIDERS } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';

const mapProviderToAutoRepoDiscoveryFF = {
  [IDENTITY_PROVIDERS.GITHUB]:
    FEATURE_FLAGS_NAMES.githubAutoRepoDiscoveryEnabled,
  [IDENTITY_PROVIDERS.GITLAB]:
    FEATURE_FLAGS_NAMES.gitlabAutoRepoDiscoveryEnabled,
  [IDENTITY_PROVIDERS.BITBUCKET]:
    FEATURE_FLAGS_NAMES.bitbucketAutoRepoDiscoveryEnabled,
  [IDENTITY_PROVIDERS.AZURE_DEVOPS]:
    FEATURE_FLAGS_NAMES.azureDevopsAutoRepoDiscoveryEnabled
};

const useAutoRepoDiscoveryFF = sensorName => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const ffValue = getSettingOrDefinitionValue({
    name: mapProviderToAutoRepoDiscoveryFF[sensorName]
  });

  return !!ffValue;
};

export default useAutoRepoDiscoveryFF;
